import React from 'react';
import './NotificationsForm.style.scss';
import '../NotificationsManager.scss';
import { PrimaryButton, SecondaryButton } from '@shape-ds/components';
import { FormProvider } from 'react-hook-form';
import NotificationsAsset from './NotificationsFormAsset/NotificationsAsset';
import { useTranslation } from 'react-i18next';
import { FormInput } from 'ui/FormComponents';
import { Create } from '@mui/icons-material';
import NotificationsFormType from './NotificationsFormType/NotificationsFormType';
import { useNotificationsForm } from './useNotificationsForm';

const NotificationsForm: React.FC<{ onCancel: () => void }> = ({ onCancel }) => {
  const { formMethods, onSubmit } = useNotificationsForm();
  const { t } = useTranslation();

  return (
    <FormProvider {...formMethods}>
      <div className="notifications-manager-form">
        <FormInput
          name="description"
          placeHolderText={t('components:notifications_manager.description')}
          icon={<Create />}
          variant="borderless"
          maxLength={80}
        />
        <NotificationsAsset />
        <NotificationsFormType />
        <div className="notifications-manager-form-actions">
          <SecondaryButton
            onClick={() => {
              formMethods.reset();
              onCancel();
            }}
          >
            {t('glossary:action_buttons.cancel')}
          </SecondaryButton>
          <PrimaryButton type="submit" onClick={onSubmit}>
            {t('components:notifications_manager.save')}
          </PrimaryButton>
        </div>
      </div>
    </FormProvider>
  );
};

export default NotificationsForm;
